(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hero-khloud"] && !Shopify.designMode) return;
  try {
    
  class KhloudHeroSlider extends HTMLElement {
    connectedCallback() {
      this.slides = Array.from(this.querySelectorAll('.khloud-hero__slide'));
      if (this.slides.length <= 1) return;

      this.dots = Array.from(this.querySelectorAll('[data-khloud-dot]'));
      this.prevBtn = this.querySelector('[data-khloud-prev]');
      this.nextBtn = this.querySelector('[data-khloud-next]');
      this.current = 0;
      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.autoplayEnabled = this.dataset.autoplay === 'true' && !this.reducedMotion;
      this.autoplaySpeed = parseInt(this.dataset.autoplaySpeed, 10) || 5000;
      this.timer = null;

      this.prevBtn && this.prevBtn.addEventListener('click', () => this.go(this.current - 1, true));
      this.nextBtn && this.nextBtn.addEventListener('click', () => this.go(this.current + 1, true));
      this.dots.forEach((dot) => {
        dot.addEventListener('click', () => this.go(parseInt(dot.dataset.khloudDot, 10), true));
      });

      this.addEventListener('keydown', (event) => {
        if (event.key === 'ArrowLeft') this.go(this.current - 1, true);
        if (event.key === 'ArrowRight') this.go(this.current + 1, true);
      });

      this.addEventListener('mouseenter', () => this.stopAutoplay());
      this.addEventListener('mouseleave', () => this.startAutoplay());
      this.addEventListener('focusin', () => this.stopAutoplay());
      this.addEventListener('focusout', () => this.startAutoplay());

      this.setupSwipe();
      this.startAutoplay();
    }

    disconnectedCallback() {
      this.stopAutoplay();
    }

    go(index, userInitiated) {
      const next = (index + this.slides.length) % this.slides.length;
      if (next === this.current) return;

      this.slides[this.current].classList.remove('khloud-hero__slide--active');
      this.slides[this.current].setAttribute('aria-hidden', 'true');
      this.slides[next].classList.add('khloud-hero__slide--active');
      this.slides[next].removeAttribute('aria-hidden');

      if (this.dots.length) {
        this.dots[this.current].classList.remove('khloud-hero__dot--active');
        this.dots[this.current].setAttribute('aria-selected', 'false');
        this.dots[next].classList.add('khloud-hero__dot--active');
        this.dots[next].setAttribute('aria-selected', 'true');
      }

      this.current = next;
      if (userInitiated) this.restartAutoplay();
    }

    startAutoplay() {
      if (!this.autoplayEnabled || this.timer) return;
      this.timer = window.setInterval(() => this.go(this.current + 1, false), this.autoplaySpeed);
    }

    stopAutoplay() {
      if (this.timer) {
        window.clearInterval(this.timer);
        this.timer = null;
      }
    }

    restartAutoplay() {
      this.stopAutoplay();
      this.startAutoplay();
    }

    setupSwipe() {
      let startX = 0;
      let tracking = false;
      const viewport = this.querySelector('.khloud-hero__viewport');
      if (!viewport) return;

      viewport.addEventListener('touchstart', (event) => {
        startX = event.touches[0].clientX;
        tracking = true;
      }, { passive: true });

      viewport.addEventListener('touchend', (event) => {
        if (!tracking) return;
        tracking = false;
        const deltaX = event.changedTouches[0].clientX - startX;
        if (Math.abs(deltaX) < 40) return;
        if (deltaX < 0) this.go(this.current + 1, true);
        else this.go(this.current - 1, true);
      }, { passive: true });
    }
  }

  customElements.define('khloud-hero-slider', KhloudHeroSlider);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
